import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const CreateNewStaffLazy = React.lazy(
	() =>
		import(/* webpackChunkName : 'AddNewStaff' */ './components/AddNewStaff')
);

export default (store) => {
	return {
		path: 'staff-setup/:campusId?/create-new-staff',
		element: <AsyncLoading component={<CreateNewStaffLazy />} />,
	};
};
